// App.js
import { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import SessionExpired from './SessionExpired';
import './main.css';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  const { sessionTimeout } = useSelector((state) => ({
    sessionTimeout: state.authReducer.sessionTimeout,
  }));

  if (sessionTimeout) {
    return <SessionExpired />;
  }

  return (
    <div className="app-container">
      <Sidebar isCollapsed={isCollapsed} toggleSidebar={toggleSidebar}/>
      <div className="main-content">
        <Header isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default App;
